const mutations = {
  ADD_LOG(state, data) {
    state.requestLog.push(data.request);
  },
  REMOVE_LOG(state, data) {
    state.requestLog.splice(state.requestLog.indexOf(data.request), 1);
  },
  SET_ERROR_MESSAGE(state, data) {
    state.errorMessage = data;
  },
  SET_ERROR_CODE(state, data) {
    state.errorCode = data;
  },
  PARSE_JWT(state, token) {
    if (token) {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`).join(''));
      // state.tokenData = JSON.parse(jsonPayload);
      const tokenData = jsonPayload;
      const tokenDataValue = JSON.parse(jsonPayload);
      localStorage.setItem('tokenData', tokenData);
      state.isReferralFlow = tokenDataValue.onBoardingType === 'referral';
      localStorage.setItem('isReferralFlow', state.isReferralFlow);
    }
  }

};
export default mutations;
